<template>
  <div
    style="width:90%;height:70vh;display:flex;flex-direction:column;align-items:center;justify-content:center"
  >
    <h6 style="margin:10px 0px;color:#888">Select Instance</h6>
    <select class="select" ref="instancePicker" v-model="selectedInstance">
      <option
        v-for="(instance,index) in $store.instances"
        :key="index"
        v-bind:value="instance.name + '@@' + instance.id"
      >{{instance.name}}</option>
    </select>
    <p style="min-height:24px">{{message}}</p>
        <a
      style="margin:10px 0px"
      class="btn btn-primary"
      @click="pushDataPackage"
      v-if="!dataPackageAvailable && selectedInstance && !initialPackagePosted"
    >Push data package</a>
    <a
      style="margin:10px 0px"
      class="btn btn-primary"
      @click="loadInstance"
      v-else
      :disabled="!dataPackageAvailable"
    >Continue</a>
  </div>
</template>
<script>
export default {
  name: "InstanceSelector",
  mounted() {
    const selector = this.$el.querySelector("select");
    if (selector) {
      M.FormSelect.init(selector, {});
    }
  },
  data() {
    return {
      dataPackageAvailable: false,
      selectedInstance: "",
      message: "",
      dataVersion: -1,
      initialPackagePosted:false
    };
  },
  watch: {
    selectedInstance: function (instance) {
      this.message = "";
      this.dataPackageAvailable = false;
      this.initialPackagePosted = true;
      this.fetchDataPackageDetails(instance);
    },
  },
  methods: {
    pushDataPackage(){
      this.initialPackagePosted = true;
      var instanceName = "start_" + this.selectedInstance.split("@@")[0];
      var update = {
        message: "First package push",
        instance: instanceName,
        update_for_device: false
      };
        this.$http.post("/settings/dataupdate", update).then((r) => {
          if (r.data.status) {
            var msg = "Package Queued. It will take around 10 minutes to generate the package.";
            M.toast({ html: msg, classes:"green"});
          } else {
            M.toast({ html: r.error_message });
          }
        });
    },
    fetchDataPackageDetails(instance) {
      const instanceName = instance.split("@@")[0];
      this.$http
        .get(
          "settings/dataupdate?instance=start_" + instanceName + "&version=0" + "&is_device=0"
        )
        .then((r) => {
          if (r.data.status) {
            if (r.data.data) {
              this.dataVersion = r.data.data.version;
              this.message =
                "Data version " +
                r.data.data.version +
                " available, posted on " +
                new Date(r.data.data.created).toLocaleString();
              this.dataPackageAvailable = true;
            } else {
              this.message = "No data package available for selected instance";
              this.dataPackageAvailable = false;
              this.initialPackagePosted = false;
            }
          } else {
            M.toast({ html: r.data.error_message, classes: "red" });
          }
        });
    },
    loadInstance() {
      var val = this.$refs.instancePicker.value + "@@" + this.dataVersion;
      this.$emit("loadInstance", val);
    },
  },
  updated() {
    if (this.$el != null) {
      const selector = this.$el.querySelector("select");
      if (selector) {
        M.FormSelect.init(selector, {});
      }
    }
  },
};
</script>

